import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const getValueByPath = (obj, path) => {
  return path.split(".").reduce((acc, key) => {
    if (!acc) return ""; // If key doesn't exist, return empty
    const match = key.match(/(.*?)\[(\d+)\]/); // Check for array index
    if (match) {
      const arrayKey = match[1]; // Extract array property
      const index = parseInt(match[2], 10); // Extract index
      return acc[arrayKey] && acc[arrayKey][index] !== undefined
        ? acc[arrayKey][index]
        : "";
    }
    return acc[key] !== undefined ? acc[key] : "";
  }, obj);
};

const ExportExcel = (data, fileName = "ExportedData", columnMapping = {}) => {
  if (!data || data.length === 0) {
    alert("No data available to export.");
    return;
  }

  if (Object.keys(columnMapping).length === 0) {
    alert("Column mapping is missing or empty.");
    return;
  }

  // Ensure all mapped keys are extracted properly
  const formattedData = data.map((item) => {
    const formattedItem = {};
    Object.entries(columnMapping).forEach(([key, header]) => {
      formattedItem[header] = getValueByPath(item, key);
    });
    return formattedItem;
  });

  // Check if formattedData is correct

  console.log("Formatted Data Sample:", formattedData.slice(0, 5));

  // Create a new worksheet & workbook
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Student Data");

  // Generate the Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Save the file
  saveAs(dataBlob, `${fileName}.xlsx`);
};

export default ExportExcel;
